import { getAllBrandsLink } from "@faire/deprecated-retailer-visitor-shared/consts/allBrandsLinks";
import { getSettingLowOrderMinimumThreshold } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingLowOrderMinimumThreshold";
import {
  buildFilterKey,
  MAKER_MINUMUM_FILTER_TYPE,
} from "@faire/retailer-shared/filters/filterKeys";

export const getNoMinimumFilterLink = (): string =>
  getAllBrandsLink({
    filters: [getNoMinimumFilter()],
  });

const getNoMinimumFilter = (): string =>
  buildFilterKey(
    MAKER_MINUMUM_FILTER_TYPE,
    `no_minimum_${getLoggedOutCurrency()}`
  );

const getLoggedOutCurrency = () =>
  getSettingLowOrderMinimumThreshold().currency === "USD"
    ? "dollars"
    : getSettingLowOrderMinimumThreshold().currency?.toLowerCase();
